import React, { useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserGroup } from '../../store/authReducer';
import { viewPermissionRefs, findPermissionRef } from '../../core/components/UserGroupPermissions';
import { getDetergentPods } from '../detergentsTemp/actions';
import { selectDetergentPods } from '../detergentsTemp/reducer';
import Detergents from './containers/Detergents';
import DetergentsTemp from '../detergentsTemp/containers/Detergents';

const DetergentsIndex = () => {
  const dispatch = useDispatch();
  const userGroup = useSelector(selectUserGroup);
  const detergentPods = useSelector(selectDetergentPods);

  // Check if user has detergent_wip permission
  const hasDetergentWipPermission = useMemo(() => {
    if (!userGroup?.permissions) return false;
    return Boolean(findPermissionRef(userGroup.permissions, viewPermissionRefs.detergent_wip));
  }, [userGroup]);

  // Fetch detergent pods if user has permission
  const handleGetDetergentPods = useCallback(() => {
    dispatch(getDetergentPods());
  }, [dispatch]);

  useEffect(() => {
    if (hasDetergentWipPermission) {
      handleGetDetergentPods();
    }
  }, [hasDetergentWipPermission, handleGetDetergentPods]);

  // Check if detergent pods exist
  const hasDetergentPods = useMemo(
    () => Boolean(detergentPods && detergentPods.length > 0),
    [detergentPods]
  );

  // Render DetergentsTemp if pods exist, otherwise render Detergents
  return hasDetergentPods ? <DetergentsTemp /> : <Detergents />;
};

export default DetergentsIndex;
